module.exports = __webpack_public_path__ + "static/003-e98ff6bb4b465c5f57f49e164cfe9b47.jpg";